"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
const material_1 = require("@mui/material");
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const styles_1 = require("@mui/material/styles");
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_theme_1 = require("@motorata/base-ui.theme");
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const StyledFormControl = (0, styles_1.styled)(FormControl_1.default)(() => ({
    "width": "100%",
    "heigth": "max-content",
    "display": "block",
    "padding-left": "20px",
    "padding-top": "27px",
    "padding-bottom": "9px",
    "background": base_ui_theme_1.baseTheme.color.background,
    "borderRadius": "3px",
    "overflow": "hidden",
    "height": "59px",
    ".MuiInputBase-root ": {
        width: "100%",
    },
    ".MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
}));
const StyledInputLabel = (0, styles_1.styled)(InputLabel_1.default)(() => {
    return {
        "opacity": 1,
        "color": base_ui_theme_1.baseTheme.color.second,
        "fontSize": base_ui_theme_1.baseTheme.font.M,
        "fontWeight": base_ui_theme_1.baseTheme.font.normal,
        "transform": "translate(20px,19px) scale(1)",
        "&.MuiInputLabel-shrink": {
            transform: "translate(20px, 11px) scale(1)",
            color: base_ui_theme_1.baseTheme.color.second,
            fontSize: base_ui_theme_1.baseTheme.font.S,
        },
    };
});
const StyledSelect = (0, styles_1.styled)(material_1.Select)(({ type }) => {
    const commons = {
        ".Mui-disabled": {
            cursor: "not-allowed",
        },
    };
    return Object.assign(Object.assign({}, commons), { ".MuiInputBase-input": {
            color: base_ui_theme_1.baseTheme.color.second,
            fontSize: base_ui_theme_1.baseTheme.font.L,
            lineHeight: base_ui_theme_1.baseTheme.font.L,
            fontWeight: base_ui_theme_1.baseTheme.font.light,
            padding: "0 !important",
            height: "23px !important",
            display: "flex",
            alignItems: "center",
        } });
});
const Select = (_a) => {
    var { options = [], 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = () => { }, value, label, shrink, name, isBig, background, disabled, error, rhf = {} } = _a, rest = __rest(_a, ["options", "onChange", "value", "label", "shrink", "name", "isBig", "background", "disabled", "error", "rhf"]);
    const { ref } = rhf, rhfRest = __rest(rhf, ["ref"]);
    const finalOptions = options.map(el => (Array.isArray(el) ? el : [el, el]));
    const handleOnChange = (e) => {
        onChange({
            name,
            value: e.target.value,
        });
    };
    const isDisabled = disabled || finalOptions.length === 0;
    return (react_1.default.createElement(base_ui_components_atoms__atoms_1.Box, Object.assign({}, rest),
        react_1.default.createElement(StyledBox, { zIndex: 0, disabled: isDisabled, background: background, isBig: isBig },
            react_1.default.createElement(StyledFormControl, null,
                react_1.default.createElement(StyledInputLabel, { shrink: shrink }, label),
                react_1.default.createElement(StyledSelect, Object.assign({ inputRef: ref, defaultValue: value, value: value, disabled: isDisabled, error: !!error, onChange: handleOnChange }, rhfRest),
                    react_1.default.createElement(MenuItem_1.default, { value: "" },
                        react_1.default.createElement("em", null, "-")),
                    finalOptions.map(option => {
                        const value = Array.isArray(option) ? option[1] : option;
                        const label = Array.isArray(option) ? option[0] : option;
                        return (react_1.default.createElement(MenuItem_1.default, { key: value, value: value }, label));
                    })))),
        error && (react_1.default.createElement(ErrorFormHelperText, null, (error === null || error === void 0 ? void 0 : error.type) === "required" ? "To pole jest wymagane" : error === null || error === void 0 ? void 0 : error.message))));
};
exports.default = Select;
const ErrorFormHelperText = (0, styled_components_1.default)(base_ui_components_atoms_typography_1.P) `
    color: ${({ theme }) => theme.color.red} !important;
    font-size: ${({ theme }) => theme.font.S};
    margin: 3px 10px;
`;
const StyledBox = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
background: none !important;
    *{
      box-sizing: border-box;
          font-family: 'Poppins';
    }
    
  ${({ theme, background }) => {
    var _a;
    return background &&
        (0, styled_components_1.css) `
      .MuiFormControl-root {
        background: ${(_a = theme.color[background]) !== null && _a !== void 0 ? _a : background};
      }
    `;
}};
    
    .MuiInputLabel-shrink: {
      color: ${({ theme }) => theme.color.second};
      font-size: ${({ theme }) => theme.font.S};
      line-height: ${({ theme }) => theme.font.S};
    }
  
      ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
          cursor: not-allowed;

          * {
            cursor: not-allowed;
          }
        `}; 
         
      ${({ isBig }) => isBig &&
    (0, styled_components_1.css) `
          .MuiFormControl-root {
            height: 70px;
            padding-top: 33px;
            padding-bottom: 14px;

            .MuiInputLabel-root {
              transform: translate(20px, 25px) scale(1) !important;
            }

            .MuiInputLabel-shrink {
              transform: translate(20px, 14px) scale(1) !important;
            }
          }
        `};
      
    `;
//# sourceMappingURL=Select.js.map